import script from "./ActiveAlertsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveAlertsModal.vue?vue&type=script&setup=true&lang=js"

import "./ActiveAlertsModal.vue?vue&type=style&index=0&id=1907529e&scoped=true&lang=css"
import "./ActiveAlertsModal.vue?vue&type=style&index=1&id=1907529e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1907529e"]])

export default __exports__